"use strict";
/*
  Email (MIME) parsing library. Copyright (C) 2020-2021 Vereign AG

  This program is free software: you can redistribute it and/or modify it under the terms of the GNU Affero General
  Public License as published by the Free Software Foundation, either version 3 of the License, or (at your option)
  any later version.

  This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the implied
  warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
  details.

  You should have received a copy of the GNU Affero General Public License along with this program. If not, see
  https://www.gnu.org/licenses/.

  In case of queries or questions, please contact us under by email under contact@vereign.com or by letter post to
  Vereign AG, Kolinplatz 10, 6300 Zug, Switzerland
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.bfsLookup = exports.extractHtmlBodyFromString = void 0;
/**
 * Function extracts all tags within <body></body> from provided string
 * and removes whitespaces between tags and HTML comments.
 * @param string
 * @returns {*}
 */
const extractHtmlBodyFromString = (string) => {
    const extractBodyRegex = /<body.*?>([\s\S]+)<\/body>/gm;
    const bodyMatch = extractBodyRegex.exec(string);
    let body = string;
    if (bodyMatch && bodyMatch[1]) {
        body = bodyMatch[1];
    }
    return body
        .replace(/>\s+</gm, "><")
        .replace(/<!--[\s\S]*?-->/gm, "")
        .trim();
};
exports.extractHtmlBodyFromString = extractHtmlBodyFromString;
const bfsLookup = (rootNode, predicate) => {
    let foundElement;
    const queue = [rootNode];
    while (queue.length) {
        const element = queue.shift();
        if (predicate(element)) {
            foundElement = element;
            break;
        }
        for (const node of element.childNodes) {
            node.nodeType === 1 && queue.push(node);
        }
    }
    return foundElement;
};
exports.bfsLookup = bfsLookup;
